import CardInfoParques from './CardInfoParques';
export default CardInfoParques;